// Discharge Planning section form field enum
export enum DischargePlanningFormField {
  DISCHARGE_PLANNING_DISCHARGE_PLANS = 'dischargePlanning/dischargePlans',
  DISCHARGE_PLANNING_REHABILITATION_POTENTIAL = 'dischargePlanning/rehabilitationPotential',
  DISCHARGE_PLANNING_NOTES = 'dischargePlanning/notes'
}
